export const baseUrl = "https://api.kandooacademy.com";
